import React, { useState } from "react";
import { useSelector } from "react-redux";
import TextbausteinNew from "../../newForms2/textbausteine/TextbausteinNew";
import { textbausteinTypes1 } from "./textbausteinTypes";
import { Table } from "react-bootstrap";
import TextbausteinSubList from "./TextbausteinSubList";

function TextbausteinList({setActiveTextbaustein}) {
  // const [showFormEdit, setShowFormEdit] = useState(false);
  const textbausteine = useSelector((st) => st.textbausteine);
  // console.log('inside StartPage', {loggedIn})
  const typeList = Object.entries(textbausteinTypes1).map(([k, v]) => {
    return { type: k, text: v.headline };
  });

  // console.log({textbausteine});

  return (
    <div className="mt-4 text-left">
      <div>
        <h4>Liste der Textbausteine</h4>
        <p>Zum Bearbeiten auf den Textbaustein klicken.</p>
        {typeList.map((type) => <TextbausteinSubList key = {type.type} type={type} setActiveTextbaustein={setActiveTextbaustein}/>)}
      </div>
    </div>
  );
}

export default TextbausteinList;
